// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"03951335","270":"a80bca4a","345":"78caeab9","346":"0c82d03a","453":"926f0775","555":"b5d255ce","788":"6da11153","956":"ccac6162","969":"e1748c8b"}[chunkId] + ".chunk.js";
};